import React from 'react';
import { NotificationsPanel } from './NotificationsPanel';
import { LanguageSelector } from './LanguageSelector';
import { Menu, X } from 'lucide-react';

export const MobileHeader = ({ isMenuOpen, onMenuToggle }) => {
  return (
    <header className="lg:hidden fixed top-0 left-0 right-0 bg-primary text-white z-40">
      <div className="flex items-center justify-between px-4 h-14">
        {/* Logo & Title */}
        <div className="flex items-center gap-2">
          <img
            src="https://customer-assets.emergentagent.com/job_design-agency-erp/artifacts/f17phjvg_%D9%84%D9%88%D9%83%D9%88%20%D8%B4%D8%B1%D9%83%D8%A9%20%D8%A8%D8%B1%D9%8A%D9%82.png"
            alt="شركة البريق"
            className="w-8 h-8 object-contain bg-white rounded-lg p-1"
          />
          <span className="font-bold font-cairo text-sm">شركة البريق</span>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-1">
          <LanguageSelector />
          <NotificationsPanel />
          <button
            onClick={onMenuToggle}
            className="p-2 rounded-lg hover:bg-white/10 transition-colors"
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
